import {
  type UseMutationResult,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import api from '@/axios';
import { GET_PRODUCTION_DECLARATION_COMMODITY_ORIGIN_PRODUCTION_PLACES_KEY } from '@/keys';

type DeleteProductionPlaceVariables = {
  productionDeclarationId: string;
  materialId: string;
  commodityOriginId: string;
  productionPlaceId: string;
  token?: string;
};

async function deleteProductionPlace({
  productionDeclarationId,
  materialId,
  commodityOriginId,
  productionPlaceId,
  token,
}: DeleteProductionPlaceVariables): Promise<void> {
  await api.delete(
    `/production-declarations/${productionDeclarationId}/materials/${materialId}/commodity-origins/${commodityOriginId}/production-places/${productionPlaceId}`,
    {
      params: token ? { token } : undefined,
    },
  );
}

export function useDeleteProductionPlace(): UseMutationResult<
  void,
  Error,
  DeleteProductionPlaceVariables
> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteProductionPlace,
    onSuccess: async (_data, variables) => {
      await queryClient.invalidateQueries({
        queryKey: [
          ...GET_PRODUCTION_DECLARATION_COMMODITY_ORIGIN_PRODUCTION_PLACES_KEY,
          variables.productionDeclarationId,
          variables.materialId,
          variables.commodityOriginId,
          variables.token ?? '',
        ],
      });
    },
  });
}
